import React from 'react';
import { useLocation } from 'react-router-dom';
import navigation from '../../../menu-items';
import { BASE_TITLE, BASENAME } from '../../../config/constant';

const SUBTITLES = {
    // Sol·licituds de Compra
    '/app/admin/solicitudes/dashboard': "Panell d'indicadors i mètriques generals de sol·licituds de compra.",
    '/app/user/solicitudes': 'Gestió i seguiment de sol·licituds de compra de departament.',
    '/app/admin/solicitudes': 'Aprovació i gestió administrativa de totes les sol·licituds de compra.',
    '/app/compras/solicitudes': 'Gestió i tramitació de comandes de compres.',
    '/app/proveedores/admin': 'Administració i registre unificat de proveïdors de la plataforma.',

    // Contractes
    '/app/admin/contratos': "Gestió i supervisió de tots els contractes vigents de l'entitat.",
    '/app/admin/contratos-archivados': 'Històric i consulta de contractes finalitzats o arxivats.',
    '/app/user/contratos': 'Consulta i gestió de contractes assignats al departament.',
    '/app/admin/contratos-administradors': "Control d'administradors i permisos sobre contractes.",

    // Documents
    '/app/user/documents-intranet': 'Gestió de fitxers i documentació interna per als clubs.',
    '/app/admin/documents-web': 'Gestió de fitxers i recursos publicats al portal web oficial.',

    // Formació
    '/app/admin/formacions': 'Administració del catàleg de cursos i formació federativa.',

    // Comunicació
    '/app/admin/noticies': 'Publicació i edició de notícies i comunicats oficials.',
    '/app/admin/galeries': "Administració d'àlbums i galeries fotogràfiques.",
    '/app/admin/bonificaciones': 'Consultes i gestió de sol·licituds de bonificació registrades pels federats.',

    // Assemblees
    '/app/assemblea/convenciolcfs/registre': 'Acreditació i registre de participants a la Convenció LCFS.',
    '/app/assemblea/convenciolcfs/checkin': "Control d'assistència i llista d'entrada a la Convenció LCFS.",
    '/app/assemblea/convenciolcfs/assistents': 'Llistat oficial d assistents confirmats a la Convenció LCFS.',
    '/app/assemblea/generalordinaria/registre': "Registre i acreditació per a l'Assemblea General Ordinària.",
    '/app/assemblea/generalordinaria/checkin': "Control d'accés i verificació de quòrum en l'Assemblea.",
    '/app/assemblea/generalordinaria/assistents': "Consulta d'assistents i representants a l'Assemblea.",

    // Stock Magatzem
    '/app/stock/admin': "Control d'inventari, entrades i eixides de material del magatzem.",
    '/app/admin/transaccions': "Històric de moviments i transaccions d'inventari.",

    // Compliance
    '/app/compliance/denuncies': "Gestió confidencial i seguiment de denúncies d'acord amb el codi ètic.",

    // Usuaris
    '/app/auth/users-admin': "Administració d'usuaris del sistema, rols de seguretat i permisos d'accés."
};

const Breadcrumb = () => {
    const location = useLocation();
    const currentPath = location.pathname;

    let matchedTitle = '';

    // 1. Exact URL Match
    const findExactTitle = (items) => {
        for (const item of items) {
            if (item.url) {
                const fullUrl = item.url.startsWith('/') ? item.url : '/' + item.url;
                if (currentPath === fullUrl || currentPath === BASENAME + fullUrl) {
                    return item.title;
                }
            }
            if (item.children) {
                const res = findExactTitle(item.children);
                if (res) return res;
            }
        }
        return null;
    };

    matchedTitle = findExactTitle(navigation.items || []);

    // 2. Longest Prefix Match (if exact match not found for sub-pages)
    if (!matchedTitle) {
        let bestLength = 0;
        const findLongestMatch = (items) => {
            for (const item of items) {
                if (item.url && item.url !== '/app' && item.url !== '/app/') {
                    const fullUrl = item.url.startsWith('/') ? item.url : '/' + item.url;
                    if (currentPath.startsWith(fullUrl) && fullUrl.length > bestLength) {
                        bestLength = fullUrl.length;
                        matchedTitle = item.title;
                    }
                }
                if (item.children) {
                    findLongestMatch(item.children);
                }
            }
        };
        findLongestMatch(navigation.items || []);
    }

    if (matchedTitle) {
        document.title = matchedTitle + BASE_TITLE;
    }

    if (!matchedTitle) return null;

    const currentSubtitle = SUBTITLES[currentPath];

    return (
        <div className="nexe-page-header mb-3" style={{ paddingTop: '0px', marginTop: '0px' }}>
            <h2 className="nexe-page-title m-0 font-weight-bold text-dark" style={{ fontSize: '1.35rem', letterSpacing: '-0.01em' }}>
                {matchedTitle}
            </h2>
            {currentSubtitle && (
                <p className="text-muted mb-0 small mt-1" style={{ fontSize: '0.84rem' }}>
                    {currentSubtitle}
                </p>
            )}
        </div>
    );
};

export default Breadcrumb;
